{
  "header": {
    "title": "Daten-Explorer",
    "description": "Erstellen, verwalten und analysieren Sie Mitarbeiterumfragen, um tiefere Einblicke zu gewinnen",
    "createButton": "Neuen Bericht erstellen"
  },
  "content": {
    "searchInput": {
      "placeholder": "Umfragen durchsuchen"
    },
    "tagsDropdown": {
      "triggerLabel": "Tags",
      "placeholder": "Tag finden",
      "options": {
        "employeeEngagement": "Mitarbeiterengagement",
        "workplaceCulture": "Arbeitsplatzkultur",
        "teamSatisfaction": "Teamzufriedenheit",
        "performanceFeedback": "Leistungsfeedback",
        "organizationalImprovement": "Organisationsverbesserung",
        "usa": "USA",
        "europe": "Europa",
        "asia": "Asien",
        "ukraine": "Ukraine"
      }
    }
  },
  "columns": {
    "reportName": "Berichtsname",
    "tags": "Tags",
    "creator": "Ersteller",
    "status": "Status"
  },
  "detailsPage": {
    "header": {
      "backButton": "Zurück zum Daten-Explorer",
      "description": "Erstellen, verwalten und analysieren Sie Mitarbeiterumfragen, um tiefere Einblicke zu gewinnen",
      "shareReportButton": "Bericht teilen",
      "editReportButton": "Bericht bearbeiten"
    },
    "cardMetrcisSection": {
      "title": "Durchschn. Mitarbeiteranzahl"
    },
    "leaderMetrcisSection": {
      "title": "Kennzahlen der Führungskraft",
      "description": "Dieses Diagramm zeigt, wie Mitarbeiter mit unterschiedlicher Betriebszugehörigkeit auf die Aussage reagiert haben.",
      "chart": {
        "title": "Zufriedenheitswert im Job"
      }
    }
  },
  "builder": {
    "header": {
      "backButton": "Zurück zum Daten-Explorer",
      "addDescriptionButton": "Beschreibung hinzufügen",
      "cancelButton": "Abbrechen",
      "saveReportButton": "Bericht speichern"
    },
    "content": {
      "notSupportedLayout": "1/3-Layout wird nicht unterstützt",
      "inputs": {
        "dateRange": {
          "label": "Datumsbereich"
        },
        "department": {
          "label": "Abteilung"
        },
        "leader": {
          "label": "Führungskraft"
        },
        "gender": {
          "label": "Geschlecht"
        },
        "location": {
          "label": "Standort"
        },
        "tenure": {
          "label": "Betriebszugehörigkeit"
        }
      },
      "charts": {
        "heatmap": {
          "title": "Intensität nach Abteilungen"
        },
        "distribution": {
          "title": "Verteilung der Antworten"
        },
        "improvement": {
          "title": "Top 5 Verbesserungsfragen im Bereich Work-Life-Balance"
        },
        "decline": {
          "title": "Top 5 Rückgangsfragen im Bereich Work-Life-Balance"
        },
        "text": {
          "title": "Kennzahlen der Führungskraft",
          "description": "Übersicht über Leistungskennzahlen und Feedback"
        }
      }
    },
    "sidebar": {
      "text": {
        "textHeading": {
          "title": "Überschrift",
          "description": "Gesamtzahl der Mitarbeitenden in der Umfrage",
          "data": {
            "title": "Kennzahlen der Führungskraft",
            "description": "Leistungskennzahlen und Feedbackübersicht des Leiters"
          }
        },
        "textSubtitle": {
          "title": "Untertitel",
          "description": "Gesamtzahl der Mitarbeitenden in der Umfrage",
          "data": {
            "title": "Kennzahlen der Führungskraft",
            "description": "Leistungskennzahlen und Feedbackübersicht des Leiters"
          }
        },
        "textBodyText": {
          "title": "Fließtext",
          "description": "Gesamtzahl der Mitarbeitenden in der Umfrage",
          "data": {
            "title": "Kennzahlen der Führungskraft",
            "description": "Leistungskennzahlen und Feedbackübersicht des Leiters"
          }
        }
      },
      "numbers": {
        "numbersAvgEmployee": {
          "title": "Durchschn. Mitarbeiteranzahl",
          "description": "Gesamtzahl der Mitarbeitenden in der Umfrage",
          "data": {
            "title": "Durchschn. Mitarbeiteranzahl",
            "description": "Gesamtzahl der Mitarbeitenden in der Umfrage"
          }
        },
        "numbersResponseCount": {
          "title": "Antwortanzahl",
          "description": "Anzahl eingereichter Antworten",
          "data": {
            "title": "Antwortanzahl",
            "description": "Anzahl eingereichter Antworten"
          }
        },
        "numbersParticipationRate": {
          "title": "Teilnahmerate",
          "description": "Prozentsatz der Mitarbeitenden, die geantwortet haben",
          "data": {
            "title": "Teilnahmerate",
            "description": "Prozentsatz der Mitarbeitenden, die geantwortet haben"
          }
        },
        "numbersAverageScore": {
          "title": "Durchschnittliche Punktzahl",
          "description": "Prozentsatz der Mitarbeitenden, die geantwortet haben",
          "data": {
            "title": "Durchschnittliche Punktzahl",
            "description": "Prozentsatz der Mitarbeitenden, die geantwortet haben"
          }
        },
        "numbersEnps": {
          "title": "eNPS",
          "description": "Prozentsatz der Mitarbeitenden, die geantwortet haben",
          "data": {
            "title": "eNPS",
            "description": "Prozentsatz der Mitarbeitenden, die geantwortet haben"
          }
        }
      },
      "graphs": {
        "graphsAvgEmployee": {
          "title": "Durchschn. Mitarbeiteranzahl",
          "description": "Gesamtzahl der Mitarbeitenden in der Umfrage",
          "data": {
            "title": "Durchschn. Mitarbeiteranzahl",
            "description": "Gesamtzahl der Mitarbeitenden in der Umfrage"
          }
        }
      }
    }
  }
}
